import { franchiseeMenu } from './franchiseeMenu';

export const signatoryMenu = [...franchiseeMenu].filter(el => el.key !== 'signatories' && el.key !== 'reports');

